import { createStore } from 'vuex'
import auth from './modules/auth'
import sched from './modules/sched'
import edit from './modules/edit'
import coredata from './modules/coredata'

const store = createStore({modules:{auth,sched,edit,coredata}})
export default store